import React, { useState } from 'react';
import { uploadFile, API_ORIGIN } from '../../api.js';

// File picker that actually uploads to the server (via /dispatch/upload)
// and shows a real thumbnail — image files preview inline, PDFs get a
// generic badge — with a click-to-enlarge lightbox. `value` is the saved
// { url, fileName } (or null); `onChange` receives the same shape once
// the upload completes.
export default function FileThumbPicker({ value, onChange, label = '+ Add file (JPEG/PDF)' }) {
  const [inputId] = useState(() => `file-input-${Math.random().toString(36).slice(2)}`);
  const [lightbox, setLightbox] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handlePick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setUploading(true);
    setError(null);
    try {
      const result = await uploadFile('/dispatch/upload', file);
      onChange({ url: result.url, fileName: result.fileName });
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const fullUrl = value ? `${API_ORIGIN}${value.url}` : null;
  const isImage = value && /\.(jpe?g|png|gif|webp)$/i.test(value.fileName || value.url);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <input id={inputId} type="file" accept="image/*,.pdf" onChange={handlePick} style={{ display: 'none' }} />
      <label htmlFor={inputId} className="link-toggle" style={{ cursor: 'pointer', margin: 0 }}>
        {uploading ? 'Uploading...' : label}
      </label>
      {value && (
        <>
          {isImage ? (
            <img src={fullUrl} alt={value.fileName} onClick={() => setLightbox(true)}
              style={{ width: 36, height: 36, objectFit: 'cover', border: '1px solid #e1e4e9', cursor: 'pointer' }} />
          ) : (
            <span onClick={() => setLightbox(true)}
              style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e1e4e9', fontSize: 9, fontWeight: 700, cursor: 'pointer', background: '#f7f8fa', color: '#5b6472' }}>
              PDF
            </span>
          )}
          <span style={{ fontSize: 12, color: 'var(--text-dim)' }}>{value.fileName}</span>
        </>
      )}
      {error && <span style={{ fontSize: 12, color: 'var(--red)' }}>{error}</span>}

      {lightbox && isImage && (
        <div className="modal-overlay" onClick={() => setLightbox(false)}>
          <img src={fullUrl} alt={value.fileName} style={{ maxWidth: '90vw', maxHeight: '90vh' }} onClick={e => e.stopPropagation()} />
        </div>
      )}
      {lightbox && value && !isImage && (
        <div className="modal-overlay" onClick={() => setLightbox(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <p>PDF preview isn't available inline — <a href={fullUrl} target="_blank" rel="noreferrer">open {value.fileName} in a new tab</a>.</p>
            <div className="modal-actions"><button type="button" onClick={() => setLightbox(false)}>Close</button></div>
          </div>
        </div>
      )}
    </div>
  );
}
